import React from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function WordCard({ name, backgroundColor, onClick, isFlipping, zoom }) {
    return (
        <div
            className={`word-card ${isFlipping ? 'zoom-out-blur' : ''}`}
            onClick={onClick}
            style={{
                backgroundColor: backgroundColor,
                transform: `scale(${zoom})`,
                color: backgroundColor === '#f9f9f9' ? 'black' : 'white',
                position: zoom > 1 ? 'relative' : 'initial',
                zIndex: zoom > 1 ? 10 : 1
            }}
        >
            {name}
        </div>
    );
}

export default WordCard;
